const activeClass = 'accordion-item-active';
const initializedAttribute = 'accordionInitialized';

document.querySelectorAll('[data-accordion-container]').forEach((container) => {
    if (container.dataset[initializedAttribute] === 'true') return;

    const accordionItems = container.querySelectorAll('.accordion-item');

    accordionItems.forEach((accordionItem) => {
        accordionItem.addEventListener('click', (event) => {
            if (event.target.closest('.accordion-body-inner')) return;

            const isActive = accordionItem.classList.contains(activeClass);

            accordionItems.forEach((item) => {
                item.classList.remove(activeClass);
            });

            if (!isActive) {
                accordionItem.classList.add(activeClass);
            }
        });
    });

    container.dataset[initializedAttribute] = 'true';
});
